import {Injectable} from "@angular/core";
import {GameId} from "@eternalfest/core/game2/game-id";
import {BehaviorSubject, Observable} from "rxjs";

@Injectable()
export class FavoritesService {
  readonly #ids$ = new BehaviorSubject<Set<GameId> | null>(null);
  readonly favoriteIds$: Observable<Set<GameId> | null> = this.#ids$.asObservable();

  replace(ids: Set<GameId>): void {
    this.#ids$.next(ids);
  }

  update(gameId: GameId, isFavorite: boolean): void {
    const current = this.#ids$.value;
    if (current === null) {
      return;
    }
    const updated = new Set(current);
    if (isFavorite) {
      updated.add(gameId);
    } else {
      updated.delete(gameId);
    }
    this.#ids$.next(updated);
  }

  reset(): void {
    this.#ids$.next(null);
  }
}
